const IS_DEV = process.env.NODE_ENV === 'development'

export default {
  serverURI: IS_DEV ? 'http://localhost:8084/api' : '/api',
  fixedLayout: false,
  hideLogoOnMobile: false,
  isTest: true,
  captchaSitekey: '6LdsADkUAAAAAE3RpM2B6_-wUOkbGgrKrhzS4Ds7'
}



// WEBPACK FOOTER //
// ./src/config/index.js